import * as React from "react";
import type { SVGProps } from "react";
const SvgIconCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.17 1.07c-.16.03-.33.16-.4.33l-.05.1v.57l-.01.58-.65.01c-.56 0-.67.01-.75.03Q1.34 3 1.1 3.94c-.02.1-.03.44-.03 4.75l.01 4.79c.09.77.67 1.35 1.43 1.45.2.02 10.8.02 10.99 0 .57-.07 1.05-.42 1.3-.93q.1-.25.14-.52l.01-4.8c0-4.3 0-4.63-.03-4.74-.14-.55-.53-1-1.03-1.18-.24-.1-.25-.1-.94-.1h-.65v-.59l-.01-.57-.04-.1c-.12-.24-.37-.37-.63-.33-.13.03-.2.06-.3.16q-.13.14-.16.33l-.01.6v.5H4.86v-.5l-.01-.6q-.03-.2-.17-.33c-.09-.1-.16-.13-.29-.16-.1-.02-.1-.02-.22 0M2.6 3.81q-.26.08-.35.3c-.03.08-.03.12-.03 1.17v1.09H13.8V5.28c0-1.05 0-1.09-.04-1.17q-.07-.17-.26-.27l-.08-.04h-.57l-.56-.01v.58l-.01.58-.04.1c-.14.3-.49.42-.78.28-.1-.05-.21-.17-.26-.26-.05-.12-.06-.23-.06-.78v-.5H4.86v.5l-.01.6q-.03.19-.16.33c-.29.28-.75.2-.93-.18l-.04-.09v-.58L3.7 3.8h-.53zm-.38 6.67v2.97l.04.07q.08.14.22.22l.08.04h10.9l.08-.04q.14-.08.22-.22l.03-.07v-2.97l.01-2.98H2.2z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconCalendar;
